import styled, { css, keyframes } from 'styled-components'
import { Icon, Text, TextButton, Link } from '@amzn/storm-ui'
import { MediaSize } from '../../../common/components/style'

export const fadeInFrames = keyframes`
  0% { opacity:0; }
  50% { opacity:0; }
  100% { opacity:1; }
`

export const fadeIn = css`
  animation: 500ms ease 0s normal forwards 1 ${fadeInFrames};
`

export const LaunchModalContainer = styled.div<{ size: MediaSize }>`
  display: flex;
  flex-direction: column;
  min-width: ${({ size }) => (size === 'medium' ? '888px' : '998px')};
  max-width: 1118px;
  min-height: 589px;
`

export const AdvertisingLogoContainer = styled.img`
  margin: 30px;
  text-align: start;
  height: 33px;
`

export const Headline = styled(Text)`
  margin: auto 0;
  text-align: center;
  justify-self: center;
  ${fadeIn};
`

export const SlideHeadline = styled(Text)`
  color: ${({ theme }) => theme.palette.white};
  margin-bottom: 20px;
`

export const SlideCaption = styled(Text)`
  color: ${({ theme }) => theme.palette.white};
`

export const SlideTextContainer = styled.div`
  width: 360px;
  align-self: center;
`

export const CloseButton = styled(TextButton)`
  margin-left: 26px;
  background: transparent;
  justify-self: end;
  padding: ${({ theme }) => theme.spacing.none};
  margin-top: -30px;
  margin-right: 30px;
  &:focus {
    outline: 0;
  }
`

export const CloseIcon = styled(Icon)`
  font-size: 20px;
  padding: 0 ${({ theme }) => theme.spacing.micro};
  color: ${({ theme }) => theme.palette.white};

  &:hover {
    cursor: pointer;
  }
`

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 190px 1fr 190px;
  background-color: ${({ theme }) => theme.palette.inkwell};
  color: ${({ theme }) => theme.palette.white};
`

export const CarouselContainer = styled.div`
  flex: 1 1 auto;
  position: relative;
  display: flex;
  flex-direction: column;
`

export const CarouselSlideContainer = styled.div`
  /* Fall back to auiblue background if linear-gradient isn't supported by the browser */
  background: ${({ theme }) => theme.palette.auiblue};
  background: linear-gradient(45deg, #0e5a65, #008787, #38b293);
  flex: 1 1 auto;
  box-sizing: content-box;
`

export const SlideLink = styled(Link)`
  &&& {
    text-decoration: underline;
    color: ${({ theme }) => theme.palette.white};
  }
  display: block;
  margin-top: 30px;
`
